export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function stringify(value: unknown): string {
  // 2026: DOMException (InvalidStateError for ViewTransition, AbortError, etc.) is not instanceof Error in some runtimes
  if (typeof DOMException !== "undefined" && value instanceof DOMException) {
    const name = (value as DOMException).name ?? "";
    const msg = (value as DOMException).message ?? "";
    return msg ? `${name}: ${msg}` : name;
  }
  if (value instanceof Error) return value.message;
  if (typeof value === "string") return value;
  if (value === null || value === undefined) return "";
  try {
    return JSON.stringify(value);
  } catch {
    // Circular or unserializable — fall back to String coercion
    return String(value);
  }
}

export function truncate(value: string, max: number): string {
  return value.length > max ? `${value.slice(0, max - 1)}\u2026` : value;
}
